<template>
  <v-select
    :model-value="modelValue"
    :items="items"
    item-title="key"
    item-value="value"
    label="ステータス"
    variant="outlined"
    @update:model-value="$emit('update:model-value', $event)"
  />
</template>

<script>
export default {
  name: "DaytimeAdviceStatusConditionSelect",
  props: {
    modelValue: {
      type: [String, Number],
      default: null
    },
    items: {
      type: Array,
      required: true
    }
  },
  emits: ["update:model-value"]
};
</script>
